<template>
  <a-modal
    :title="title === '1' ? $t('add') : $t('edit')"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'seatType')">
          <a-select v-decorator="[ 'type', validatorRules.type]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'seatType')" @change="onChange">
            <a-select-option v-for='item in seatTypes' :key='item.value'>
              {{item[fieldName]}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'seatMobile')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'seatMobile')" v-decorator="[ 'mobile', validatorRules.mobile]" :readOnly="checkTitle && readOnly"/>
          <a-button @click="autoGen" type="primary" v-if='checkTitle()'>{{ $t(I18N_KEY + 'autoGen') }}</a-button>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'seat')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'seat')" v-decorator="[ 'seat', validatorRules.seat]" :readOnly="checkTitle && readOnly"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'userName')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'userName')" v-decorator="[ 'userName', validatorRules.userName]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'password')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'password')" v-decorator="[ 'password', validatorRules.password]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'cloudCallSeat')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'cloudCallSeat')" v-decorator="[ 'callUsername', validatorRules.callUsername]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'cloudCallSeatPassword')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'cloudCallSeatPassword')" v-decorator="[ 'callPassword', validatorRules.callPassword]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'userGroup')">
          <a-select v-decorator="[ 'groupId', validatorRules.groupId]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'userGroup')">
            <a-select-option v-for='item in userGroups' :key='item.value'>
              {{item[fieldName]}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'seatStatus')">
          <a-radio-group
            v-decorator="['status', { initialValue: '0' }]">
            <span v-for="item in this.statuses">
              <a-radio :value=item>{{ $t(I18N_KEY + 'seatStatus_' + item) }}</a-radio>
            </span>
          </a-radio-group>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { autoGen} from '@/webpublicapi/teleMarket';
const I18N_KEY = 'teleMarket.';
export default {
  name: "UserManageModal",
  props: {
    seatTypes: {
      type: Array,
      default: () => [],
    },
    userGroups: {
      type: Array,
      default: () => [],
    },
    fieldName:{
      type: String,
      default: 'textCn',
    }
  },
  data () {
    return {
      I18N_KEY,
      title:"Action",
      visible: false,
      readOnly: true,
      statuses: ["0","1"],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules:{
        type:{
          rules: [
            { required: true, message: 'Please input type!' },
          ]},
        mobile:{
          rules: [
            { required: true, message: 'Please input mobile!' },
          ]},
        seat:{
          rules: [
            { required: true, message: 'Please input seat!' },
          ]},
        userName:{
          rules: [
            { required: true, message: 'Please input userName!' },
          ]},
        password:{
          rules: [
            { required: false, message: 'Please input password!' },
          ]},
        groupId:{
          rules: [
            { required: false},
          ]},
        callUsername:{
          rules: [
            { required: false },
          ]},
        callPassword:{
          rules: [
            { required: false },
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    checkTitle() {
      return this.title === '1';
    },
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model,
        status: this.model.status != undefined && this.model.status != null && this.model.status != '' ? '' + this.model.status : '0',
        type: this.model.type != undefined && this.model.type != null && this.model.type != '' ? this.model.type : 'system',
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'type', 'mobile', 'seat', 'userName','password', 'groupId', 'status','callUsername','callPassword'))
      });

    },
    onChange(value) {
      if(value == 'ai') {
        this.readOnly = false
      }
      if(value == 'system') {
        this.readOnly = true
      }
    },
    autoGen() {
      autoGen({}).then((res) => {
        if (res.code === 1000) {
          var record = {
            'type': 'system',
            'mobile': res.data.mobile,
            'userName': res.data.mobile,
            'seat': res.data.seat,
            'password': res.data.password,
          }

          this.model1 = Object.assign({}, record)
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model1,'type','mobile', 'userName','seat','password'))
          });
        } else {
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    handleOk () {
      const that = this;
      console.log(this.form)
      if(this.title === '1' && (this.form.fieldsStore.fields.password.value == undefined || this.form.fieldsStore.fields.password.value == null | this.form.fieldsStore.fields.password.value == '')) {
        this.$message.error('Please input password!')
        return
      }
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    handleCancel () {
      this.close()
    },
  }
}
</script>

<style scoped>

</style>